import { render, staticRenderFns } from "./MAppNotification.vue?vue&type=template&id=df77bf04"
import script from "./MAppNotification.vue?vue&type=script&lang=ts"
export * from "./MAppNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports